import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { connect } from 'react-redux';

import Title from '../Titles/Title';
import { PaddedModalBody } from './ModalContainers/ModalContainers';
import Heart from '../../../assets/svg/Heart';
import DefaultButton from '../Buttons/DefaultButton';
import OutlineButton from '../Buttons/OutlineButton';

import colors from '../../../styling/colors';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

import { openLogInModal, openSignUpModal } from '../../../redux/modals';

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  @media (${DESKTOP_START_QUERY}) {
    margin-top: 4.5rem;
  }
`;

const Body = styled.p`
  text-align: center;
  line-height: 1.5rem;
  font-size: 1rem;
  margin-bottom: 2rem;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const LogInButton = styled(OutlineButton)`
  width: 50%;
  margin-right: 1.25rem;
`;

const SignUpButton = styled(DefaultButton)`
  width: 50%;
`;

export class FavoriteModal extends Component {
  static propTypes = {
    openLogInModal: PropTypes.func.isRequired,
    openSignUpModal: PropTypes.func.isRequired,
  };

  render() {
    const { openLogInModal, openSignUpModal, isMobile } = this.props;

    return (
      <PaddedModalBody isMobile={isMobile}>
        <Content>
          <Heart strokeColor={colors('paloma')} fillColor={colors('paloma')} />
          <Title>Add to Favorites</Title>
          <Body>
            To save this design to your favorites list, please log in or sign
            up.
          </Body>
          <Row>
            <LogInButton onClick={openLogInModal}>Log In</LogInButton>
            <SignUpButton onClick={openSignUpModal}>Sign Up</SignUpButton>
          </Row>
        </Content>
      </PaddedModalBody>
    );
  }
}

const mapStateToProps = ({ env: { isMobile } }) => ({
  isMobile,
});

const mapDispatchToProps = {
  openLogInModal,
  openSignUpModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteModal);
